import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tooltip-arrow",
  "use": "icon-tooltip-arrow-usage",
  "viewBox": "0 0 10 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 9\" fill=\"none\" id=\"icon-tooltip-arrow\">\n  <path d=\"M6.06891 8C5.68401 8.66667 4.72176 8.66667 4.33686 8L0.872755 2C0.487855 1.33333 0.968981 0.499999 1.73878 0.499999L8.66698 0.5C9.43678 0.5 9.91791 1.33333 9.53301 2L6.06891 8Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol